// Fichier généré à partir des données Cosmic (exemple)
// Tu peux mettre à jour ce fichier manuellement ou via un script

const dataAvis = [
  {
    id: "1",
    title: "Super collaboration !",
    metadata: {
      message:
        "Nous avions commandé, mon mari et moi, un site pour répertorier nos livres en ligne, de manière privé. Nous avons été très surpris par la beauté du site. Je recommande les services très professionnels de Sandrine.",
      auteur: "J-Claude & Marie F.",
      societe: "Bibliothèque en ligne",
      date_de_publication: "2025-06-26",
    },
  },
  {
    id: "2",
    title: "Excellente webmaster",
    metadata: {
      message:
        "Webmaster de l’association Sandrine est à votre écoute pour définir votre projet de site internet. Son solide sens de l’associatif et du travail bien fait fera le reste. Aucune hésitation à la consulter, le seul risque est la bonne surprise :+)",
      auteur: "Ridha S.",
      societe: "Spadtribu",
      date_de_publication: "2025-01-04",
    },
  },
  {
    id: "3",
    title: "Très professionnel",
    metadata: {
      message:
        "Très professionnel, à l écoute de chaque demande, travail personnalisé, patience et efficacité garanties. Je recommande vivement !!!",
      auteur: "Virginie A.",
      societe: "Électricité Armanini",
      date_de_publication: "2024-12-10",
    },
  },
  {
    id: "4",
    title: "Très professionnel",
    metadata: {
      message:
        "Une vraie amélioration de notre image en ligne, avec un site clair et fluide. Merci Sandrine !",
      auteur: "Gaëlle & Richard",
      societe: "Archers",
      date_de_publication: "2023-02-02",
    },
  },
];

export default dataAvis;
